/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line no-use-before-define
import React from 'react';

import sendError from '../../modules/sendError';
import {
  Info,
  LandingFormWrapperStyled,
  SectionsTitle,
  SectionsTitleWrapper,
  Text,
  TitleLine,
} from './ErrorBoundary.styles';

interface State {
  hasError: boolean;
}

// eslint-disable-next-line @typescript-eslint/ban-types
class ErrorBoundary extends React.Component<{}, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  async componentDidCatch(error, errorInfo) {
    sendError(error, errorInfo.componentStack);
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.hasError) {
      return (
        <LandingFormWrapperStyled size={850}>
          <SectionsTitleWrapper>
            <SectionsTitle>Sorry something went wrong</SectionsTitle>
          </SectionsTitleWrapper>
          <TitleLine />
          <Info>
            <Text>
              Sorry for the inconvenience. Something went wrong. Our team was
              notified and we will fix the issue soon. Please try this action
              again in a couple days.
            </Text>
            <Text>
              <a href="https://bid2board.com">
                Click here to go back to bid2board.com
              </a>
            </Text>
          </Info>
        </LandingFormWrapperStyled>
      );
    }

    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}

export default ErrorBoundary;
